import { render, staticRenderFns } from "./FeeList.vue?vue&type=template&id=57b33cbe&scoped=true&"
import script from "./FeeList.vue?vue&type=script&lang=js&"
export * from "./FeeList.vue?vue&type=script&lang=js&"
import style0 from "./FeeList.vue?vue&type=style&index=0&id=57b33cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b33cbe",
  null
  
)

export default component.exports